import api, { login, signup, reset } from "actions/api.js"


export function postLogin(email, pass) {
    return login({
        method: "POST",
        body: JSON.stringify({ email, pass })
    })
}

export function getUserFromToken(token) {
    return api("token")
}

export function changePassword(id, oldpwd, newpwd) {
    return api(`password/${id}`,
        {
            method: "PUT",
            body: JSON.stringify({ oldpwd, newpwd })
        })
}

export function resetPassword(email) {
    return reset({
        method: "POST",
        body: JSON.stringify({ email })
    })
}

export function deleteProfile(id) {
    return api(`user/${id}`,
        {
            method: "DELETE"
        })
}

export function postSignup(user) {
    return signup({
        method: "POST",
        body: JSON.stringify(user)
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/user/api.js
 **/